export const DEFAULT_LIMIT_ITEM = 5;

export const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];
